import { useMemo } from 'react';

import useAppSelector from '@webclient/hooks/useAppSelector';
import useWorkspace from '@webclient/hooks/useWorkspace';

import { IconButton } from '@knowz/knowz-ui';
import CONFIG from '@webclient/layouts/main/sections/toolbar/config';
import { StyledListItem } from '@webclient/layouts/main/sections/toolbar/mini/styles';
import { StyledNavLink } from '@webclient/layouts/main/sections/toolbar/styles';

export default function RenderListItemIcon() {
  const me = useAppSelector((state) => state.auth.me);
  const { setupMode } = useWorkspace();

  const MemoizedToolbarItems = useMemo(
    () =>
      CONFIG.TOOLBAR_ITEMS.filter(
        ({ isAlpha }) => me?.alpha || !isAlpha,
      ).filter(({ setupMode: singleSetupMode }) =>
        singleSetupMode.includes(setupMode),
      ),
    [me?.alpha, setupMode],
  );

  return MemoizedToolbarItems.map(({ icon, url }, i) => (
    <StyledListItem
      key={i}
      sx={{ marginBlockEnd: 0 }}
      disablePadding
      disableGutters
      component={StyledNavLink}
      to={url}
    >
      <IconButton
        variant="ghost"
        color="secondary"
      >
        {icon}
      </IconButton>
    </StyledListItem>
  ));
}
